import { useCallback, useContext, useMemo } from "react";
// context
import { CartIPLSwiggySixesContext } from "@swiggy-private/core-ui";
import { ProceedMode, useLocalStorageBasedFrequencyCapping } from "@swiggy-private/checkout-core";
// type
import { ApplyCouponPotentialCommsType } from "@swiggy-private/cart-types";
// helpers
import { isCommsTypeFTUE, isCommsTypeIPL } from "../utils";

// constants
import { FOOTER_COMMS_CLICK_FREQUENCY_CAP_PAYLOAD, FOOTER_COMMS_VIEW_FREQUENCY_CAP_PAYLOAD } from "../constants";

export const useFooterCommsVisibility = (type: ApplyCouponPotentialCommsType) => {
    const { tickerTimerInMinSec } = useContext(CartIPLSwiggySixesContext);
    const { shouldProceed: checkClickFreq } = useLocalStorageBasedFrequencyCapping(
        FOOTER_COMMS_CLICK_FREQUENCY_CAP_PAYLOAD,
    );
    const { shouldProceed: checkViewFreq } = useLocalStorageBasedFrequencyCapping(
        FOOTER_COMMS_VIEW_FREQUENCY_CAP_PAYLOAD,
    );

    const allowCommsRender = useMemo(() => {
        if (isCommsTypeIPL(type)) {
            // for IPL comms type we have a requirement to control comms visibility based on timer duration
            // absolute comms control is with backend to populate data, we control the visiblity based on IPL timer
            return tickerTimerInMinSec.enabled;
        }
        if (isCommsTypeFTUE(type)) {
            return (
                checkClickFreq({ mode: ProceedMode.ONLY_CHECK }) &&
                checkViewFreq({ mode: ProceedMode.CHECK_AND_UPDATE })
            );
        }
        return true;
    }, [checkClickFreq, checkViewFreq, tickerTimerInMinSec.enabled, type]);

    const updateFrequencyCounter = useCallback(() => {
        if (isCommsTypeFTUE(type)) {
            return checkClickFreq({ mode: ProceedMode.CHECK_AND_UPDATE });
        }
    }, [checkClickFreq, type]);

    return {
        allowCommsRender,
        updateFrequencyCounter,
    };
};
